import * as React from 'react';
import { Provider } from 'react-redux';
import configureStore from './store/createStore';
import { startListeningToAuthChanges } from './components/auth/';
import { ApplicationContainer } from './components/application/';
import './App.less';
import { startListeningForCharities } from './components/charity/CharityOperations';
import { startListeningForDonations } from './components/donation/';
import { startListeningForCampaigns } from './components/campaign';
import { startListeningForPlacements } from './components/placement';
import { getPetitions } from './components/petition';
import MuiThemeProvider from './MuiThemeProvider'
import {fetchAllPaypalConnectAccountsRequest} from './components/paypal-connect/reducer'
import rootSaga from "./sagas";

const store = configureStore();
store.runSaga(rootSaga);

export default class App extends React.Component<{}, {}> {
  render() {
    return (
      <Provider store={store}>
        <MuiThemeProvider>
          <ApplicationContainer/>
        </MuiThemeProvider>
      </Provider>
    );
  }
}

// @todo: add a bootstrapper for the listeners?
store.dispatch(startListeningToAuthChanges());
store.dispatch(startListeningForCharities());
store.dispatch(fetchAllPaypalConnectAccountsRequest());
store.dispatch(startListeningForDonations());
store.dispatch(startListeningForCampaigns());
store.dispatch(startListeningForPlacements());
store.dispatch(getPetitions());
